module.exports = __webpack_public_path__ + "img/7.9d0e58c3.jpg";